/* eslint-disable max-len */
import React from 'react';

export function SchedulesIcon(): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
      <path
        d="M4.5 0.5V2.5H13.5V0.5H14.5V2.5H16C16.8239 2.5 17.5 3.17614 17.5 4V18C17.5 18.8239 16.8239 19.5 16 19.5H2C1.16777 19.5 0.5 18.8255 0.5 18L0.509766 4C0.509766 3.17123 1.17103 2.5 2 2.5H3.5V0.5H4.5ZM1.5 18.5H16.5V6.5H1.5V18.5ZM13.5 9.5V10.5H12.5V9.5H13.5ZM9.5 9.5V10.5H8.5V9.5H9.5ZM5.5 9.5V10.5H4.5V9.5H5.5Z"
        stroke="white"
        strokeOpacity="0.54"
      />
    </svg>
  );
}

export function ActiveSchedulesIcon(): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
      <path
        d="M6 9H4V11H6V9ZM10 9H8V11H10V9ZM14 9H12V11H14V9ZM16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V7H16V18Z"
        fill="white"
      />
    </svg>
  );
}
